import Nullable from '@/types/nullable';
import RiskProfileItem from '@/types/risk-profile-item';
import User from '@/types/user';
import { PERMISSIONS, userHasPermission } from '@/utils/permissions';

export const validateUpRisk = (profile: RiskProfileItem | undefined, recommendedRiskProfile: RiskProfileItem | undefined, user: Nullable<User | undefined>) => {
  const upRiskFlagging = userHasPermission(user, PERMISSIONS.KYC_UP_RISK_WARNING);
  const isUprisk = profile?.order && recommendedRiskProfile?.order && recommendedRiskProfile.order < profile.order;

  return !!(upRiskFlagging && isUprisk);
};
